<template>
  <!-- Component không render DOM riêng; nó bọc SweetAlert2 để có modal căn giữa,
       có icon cảnh báo và nút màu đỏ (giống mẫu order ban đầu). -->
  <span style="display: none"></span>
</template>

<script>
import Swal from 'sweetalert2';

// Modal xác nhận dùng chung (SweetAlert2). Chỉ nhận dữ liệu qua props và emit sự
// kiện ra ngoài; KHÔNG tự xử lý hành động — nơi dùng lắng nghe @confirm / @cancel
// để tự quyết định (reload trang, gọi API, v.v.). Cha gọi qua ref: this.$refs['...'].show().
export default {
  name: 'ConfirmActionModal',
  props: {
    title: {
      type: String,
      default: 'Xác nhận',
    },
    message: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'Xác nhận',
    },
    cancelText: {
      type: String,
      default: 'Hủy',
    },
    icon: {
      type: String,
      default: 'warning',
    },
    // Hiện nút hủy (mặc định chỉ có nút xác nhận).
    showCancel: {
      type: Boolean,
      default: false,
    },
    // Cho phép đóng bằng backdrop/esc (mặc định false để buộc chọn).
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show() {
      Swal.fire({
        title: this.title,
        text: this.message,
        icon: this.icon,
        allowOutsideClick: this.dismissible,
        allowEscapeKey: this.dismissible,
        showCancelButton: this.showCancel,
        confirmButtonColor: '#DD3333',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: this.confirmText,
        cancelButtonText: this.cancelText,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit('confirm');
        } else {
          this.$emit('cancel');
        }
      });
    },
    hide() {
      Swal.close();
    },
  },
};
</script>
